import {
	SettingsContainer, SettingsHeader, SettingsOptionsContainer, Understanding
} from '../components/SettingsStyles'
import { TransferPage } from '../../../interfaces/enums';
import TransferLogin from '../components/TransferLogin';
import TransferLineups from '../components/TransferLineups';
import { useAppSelector } from '../../../app/hooks';
import { selectTransferPage } from '../SettingsState/userSlice';

const OldTitanTransfer = () => {
	return (
		<SettingsContainer>
			<SettingsOptionsContainer>
				<SettingsHeader>
					Transfer your settings, lineups and favorites
				</SettingsHeader>
				<TransferSwitch />
			</SettingsOptionsContainer>
			<Understanding>
				<span>
					<b>About this Page:</b>
					<p></p>
				</span>
			</Understanding>
		</SettingsContainer>
	)
}

const TransferSwitch = () => {
	const pageMode = useAppSelector(selectTransferPage)

	switch (pageMode) {
		case TransferPage.LOGIN:
			return <TransferLogin />
		case TransferPage.LINEUPS:
			return <TransferLineups />
		default:
			return <TransferLogin />
	}

}

export default OldTitanTransfer